import SmallVideoBlock from './SmallVideoBlock';

export default SmallVideoBlock;
